import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import { M21_TOPICS, M21_MODULE_INFO } from '../data/mathExercises/M21_Probability';
import { M21_ALL_PROBLEMS } from '../data/mathExercises/M21_ProblemsData';

const M21ProbabilityExercise = ({ onProgress }) => {
  return (
    <ExerciseInterface
      moduleInfo={M21_MODULE_INFO}
      topics={M21_TOPICS}
      problems={M21_ALL_PROBLEMS}
      onProgress={onProgress}
      className="m21-exercise"
    />
  );
};

export default M21ProbabilityExercise; 